((IconBar) => {
  'use strict';

  const options = {
    autoplay: false,
    arrows: true,
    dots: false,
    infinite: true,
    slidesToShow: 2,
    slidesToScroll: 1
  };

  const toggleSlider = () => {
    // jquery because slick
    const $iconBarSlider = $('[data-icon-bar]');

    if (window.innerWidth > 800) {
      if (!$iconBarSlider.hasClass('slick-slider')) return;

      $iconBarSlider.slick('unslick');
      return;
    }

    if ($iconBarSlider.hasClass('slick-slider')) return;
    $iconBarSlider.slick(options);
  };

  const bindUIActions = () => {
    window.addEventListener('resize', toggleSlider);
  };

  const init = () => {
    toggleSlider();
    bindUIActions();
  };

  IconBar.init = init;
})(window.IconBar = window.IconBar || {});
